import pSBC from "shade-blend-color";

export default {
  props: {
    label: String,
    name: String,
  },
  data() {
    return {
      isSwatch: true,
      color: "#ef8400",
      colorSwatches: [
        "#ef8400",
        "#ffbe02",
        "#1aa763",
        "#0ea5c0",
        "#4f3b9e",
        "#962074",
        "#c11111",
      ],
      subSwatches: [],
    };
  },
  created() {
    this.buildShades();
  },
  methods: {
    buildClasses() {
      const result = [];

      if (this.classes) {
        result.concat(this.classes);
      }

      if (this.colorScheme) {
        result.push(`vinput--${this.colorScheme}`);
      }

      return result;
    },
    handleSwatchInput(e) {
      this.setColor(e.currentTarget.value);
    },
    setColor(color) {
      this.color = color;

      this.buildShades();
    },
    buildShades() {
      this.subSwatches = [];

      this.subSwatches = this.colorSwatches.map((swatch, index) => {
        //middle swatch index
        const middelIndex = Math.round((this.colorSwatches.length - 1) / 2);

        if (middelIndex > index) {
          return pSBC((middelIndex - index) * 0.1, this.color);
        } else if (middelIndex === index) {
          return this.color;
        } else {
          return pSBC(-(index * 0.1), this.color);
        }
      });
    },
  },
};
